module.exports = __webpack_public_path__ + "static/media/duplicateShift3.1463a440.svg";